import state from '../../state'

/**
 * handleSrciReady
 * @description Gives the initial parameters to SRCI when it becomes
 * ready. (locale, srciAction, unbindError)
 */
export default function handleSrciReady () {
  const _unbindError = state.unbindError
  // Reset unbindError to false so that the error modal does not show up
  // from a cached unbindError response
  state.unbindError = false
  return {
    locale: state.locale,
    srciActionCode: state.srciActionCode,
    unbindError: _unbindError
  }
}
